import { useToLocaleDateTime } from "b2b/i18n";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "dateDayMonthTime",
  placeholderText: "17. března",
  content: ({ val }) => useToLocaleDateTime()(val)
});
